module.exports = __webpack_public_path__ + "img/72.af7d6e3f.png";